<template>
  <div class="forecast-day">
    <div class="day-word tc ttu o-70">
      {{ date }}
    </div>
    <div class="weather-icon tc">
      <span :class="iconClass"></span>
    </div>
    <div class="day-temps o-70 tc">
      <p><span>H:</span> <strong>{{ tempHigh }}&ordm;</strong> /
         <span>L:</span> <strong>{{ tempLow }}&ordm;</strong></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ForecastDay',
  props: ['day', 'index'],
  computed: {
    tempUnit() {
      return this.temperatureUnit == 'metric' ? 'C' : 'F';
    },
    tempHigh() {
      return this.day
        ? this.temperatureUnit === 'metric'
          ? this.formatTemp(this.day.temp_high_c)
          : this.formatTemp(this.day.temp_high_f)
        : '-';
    },
    tempLow() {
      return this.day
        ? this.temperatureUnit === 'metric'
          ? this.formatTemp(this.day.temp_low_c)
          : this.formatTemp(this.day.temp_low_f)
        : '-';
    },
    iconClass() {
      if (this.day && this.day.icon) {
        return `ico-${this.day.icon.replace(/\.svg/g, '')}`;
      }
    },
    date() {
      if (!this.day) { return; }

      const date = new Date(this.day.date);
      date.setDate(date.getDate() + 1);
      const day = (`${date} `).split(' ')[0];
      return this.$t(day);
    },
    ...mapState(['temperatureUnit']),
  },
  methods: {
    formatTemp(temp) {
      if (temp) {
        return temp.split('.')[0];
      }
      return '-';
    },
  },
};
</script>

<style lang="scss" scoped>
.weather-icon {
  font-size: 40px;
}

.forecast-day, .day-temps {
  color: $dark-gray;
  font-family: $proxima-regular;
  font-size: 15px;
  min-width: 100px;
  p {
    color: $dark-gray;
    font-family: $proxima-regular;
    font-size: 15px;
    letter-spacing: -0.3px;
    line-height: 1.2;
  }
}

</style>

<i18n locale="fr-ca">
{
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mer",
  "Thu": "Jeu",
  "Fri": "Ven",
  "Sat": "Sam",
  "Sun": "Dim"
}
</i18n>
